module.exports = __webpack_public_path__ + "img/202307_07.0606b75d.jpg";